import React, { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import janitorialService from "../../services/web/janitorial-service.js";
import projectUtils from "../../utils/project-utils.js";
import {Modal} from "./modal.jsx";
import Button from "../button/button.jsx";
import InputTextarea from "../input/input-textarea.jsx";
import {toast} from "react-toastify";

const CloseTaskModal = ({ open, setOpen, task, currentUser, janitorialId }) => {
    const queryClient = useQueryClient();
    const [cancelObservation, setCancelObservation] = useState("");
    const [closeModalError, setCloseModalError] = useState("");

    useEffect(() => {
        if (open) {
            setCancelObservation("");
            setCloseModalError("");
        }
    }, [open]);

    const closeTaskMutation = useMutation({
        mutationFn: (payload) => janitorialService.closeDispatchTask(payload),
        onSuccess: () => {
            toast.success("Salvo com sucesso");
            setOpen(false);
            queryClient.invalidateQueries({ queryKey: ['janitorial', janitorialId] });
            queryClient.invalidateQueries({ queryKey: ['janitorial-task', janitorialId] });
        },
        onError: (error) => {
            console.error("Erro ao encerrar tarefa:", error);
            let message = "Não foi possível encerrar a tarefa.";
            if (error?.response?.data) {
                message = error.response.data.errorMessages ?? error.response.data.message ?? message;
            }
            projectUtils.swalErrorMessage("", message);
        }
    });

    const handleConfirmCloseTask = () => {
        if (!cancelObservation.trim()) {
            setCloseModalError("O campo 'Motivo do encerramento' é obrigatório.");
            return;
        }

        closeTaskMutation.mutate({
            taskId: task?.id,
            cancelObservation: cancelObservation,
            userId: currentUser?.id
        });
    };

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            centered
            backdrop="static"
            keyboard={false}
            title={"Encerrar tarefa"}
            className={"w-4/12"}
            isCloseClick={false}
            showCloseButton={true}
        >
            <Modal.Body className={"p-4 space-y-4"}>
                <div className="w-full">
                    <InputTextarea
                        id="task-close-observation"
                        label="Motivo do encerramento *"
                        value={cancelObservation}
                        onChange={(e) => {
                            setCancelObservation(e.target.value);
                            if (closeModalError) setCloseModalError("");
                        }}
                        textAreaClass="h-[120px]"
                    />
                </div>

                {closeModalError && (
                    <div className="w-full p-2 text-sm text-center text-red-600 bg-red-50 border border-red-200 rounded">
                        {closeModalError}
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <div className={"w-full flex gap-2 justify-end"}>
                    <Button loading={closeTaskMutation.isPending} onClick={handleConfirmCloseTask} actionFeedbackType="save">
                        Salvar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseTaskModal;